import Swal from "sweetalert2";
import { decodeTokenLS } from "../utils/token";

// Permite override por env var. Default a same-origin (path '') para producción.
// En dev local: REACT_APP_API_URL=http://localhost:3000
export const URL_REQUEST = process.env.REACT_APP_API_URL || 'https://prod-api-comandas.viuti.io';

// F6: evita disparar el popup de sesión expirada varias veces si varios requests salen en paralelo.
let sessionExpiredHandled = false;

function handleSessionExpired(): void {
    if (sessionExpiredHandled) return;
    sessionExpiredHandled = true;
    try { localStorage.removeItem("token"); } catch (_) { /* noop */ }
    // Aviso al usuario y redirección a login. Usamos Swal directo para no acoplar a showAlert.
    Swal.fire({
        title: "Sesión expirada",
        text: "Tu sesión ha expirado. Vuelve a iniciar sesión para continuar.",
        icon: "warning",
        confirmButtonText: "Iniciar sesión",
        allowOutsideClick: false,
    }).then(() => {
        window.location.href = "/inicio";
    });
}

export function setHeaders(): Headers {

    const decoded = decodeTokenLS();
    if (decoded) {
        const { token, exp } = decoded;
        // F6: detectar expiración del JWT antes de salir con el request.
        // `exp` viene en segundos epoch. Si ya expiró, mostramos popup y abortamos.
        if (typeof exp === "number" && exp > 0 && Date.now() / 1000 >= exp) {
            handleSessionExpired();
            const fallbackHeaders = new Headers();
            fallbackHeaders.append("Content-Type", "application/json");
            return fallbackHeaders;
        }
        const myHeaders = new Headers();
            myHeaders.append("accept", "application/json, text/plain, */*")
            myHeaders.append("accept-language", "es-ES,es;q=0.9,en;q=0.8,pt;q=0.7")
            myHeaders.append("x-access-token", token)

            myHeaders.append("content-type", "application/json")

        return myHeaders;
    }
    // F6: no hay token y estamos intentando hacer un request autenticado → sesión perdida.
    handleSessionExpired();
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    return myHeaders;

}

// F6: helper exportado para que las capas de request detecten 401 en las respuestas y
// disparen el mismo flujo de sesión expirada.
export function handle401(res: { status?: number } | undefined | null): boolean {
    if (res && res.status === 401) {
        handleSessionExpired();
        return true;
    }
    return false;
}
